const emojisDefault = [
  ['😀', 'Peoples', ['grinning']],
  ['😄', 'Peoples', ['smile']],
  ['😁', 'Peoples', ['grin']],
  ['😆', 'Peoples', ['laughing', 'satisfied']],
  ['😅', 'Peoples', ['sweat_smile']],
  ['😂', 'Peoples', ['joy']],
  ['🤣', 'Peoples', ['rofl']],
  ['😃', 'Peoples', ['smiley']],
  ['😌', 'Peoples', ['relaxed']],
  ['😊', 'Peoples', ['blush']],
  ['😇', 'Peoples', ['innocent']],
  ['🙂', 'Peoples', ['slightly_smiling_face']],
  ['🙃', 'Peoples', ['upside_down_face']],
  ['😉', 'Peoples', ['wink']],
  ['😌', 'Peoples', ['relieved']],
  ['😍', 'Peoples', ['heart_eyes']],
  ['😘', 'Peoples', ['kissing_heart']],
  ['😗', 'Peoples', ['kissing']],
  ['😙', 'Peoples', ['kissing_smiling_eyes']],
  ['😚', 'Peoples', ['kissing_closed_eyes']],
  ['😋', 'Peoples', ['yum']],
  ['😜', 'Peoples', ['stuck_out_tongue_winking_eye']],
  ['😝', 'Peoples', ['stuck_out_tongue_closed_eyes']],
  ['😛', 'Peoples', ['stuck_out_tongue']],
  ['🤑', 'Peoples', ['money_mouth_face']],
  ['🤗', 'Peoples', ['hugs']],
  ['🤓', 'Peoples', ['nerd_face']],
  ['😎', 'Peoples', ['sunglasses']],
  ['🤡', 'Peoples', ['clown_face']],
  ['🤠', 'Peoples', ['cowboy_hat_face']],
  ['😏', 'Peoples', ['smirk']],
  ['😒', 'Peoples', ['unamused']],
  ['😞', 'Peoples', ['disappointed']],
  ['😔', 'Peoples', ['pensive']],
  ['😟', 'Peoples', ['worried']],
  ['😕', 'Peoples', ['confused']],
  ['🙁', 'Peoples', ['slightly_frowning_face']],
  ['☹️', 'Peoples', ['frowning_face']],
  ['😣', 'Peoples', ['persevere']],
  ['😖', 'Peoples', ['confounded']],
  ['😫', 'Peoples', ['tired_face']],
  ['😩', 'Peoples', ['weary']],
  ['😤', 'Peoples', ['triumph']],
  ['😠', 'Peoples', ['angry']],
  ['😡', 'Peoples', ['rage', 'pout']],
  ['😶', 'Peoples', ['no_mouth']],
  ['😐', 'Peoples', ['neutral_face']],
  ['😑', 'Peoples', ['expressionless']],
  ['😯', 'Peoples', ['hushed']],
  ['😦', 'Peoples', ['frowning']],
  ['😧', 'Peoples', ['anguished']],
  ['😮', 'Peoples', ['open_mouth']],
  ['😲', 'Peoples', ['astonished']],
  ['😵', 'Peoples', ['dizzy_face']],
  ['😳', 'Peoples', ['flushed']],
  ['😱', 'Peoples', ['scream']],
  ['😨', 'Peoples', ['fearful']],
  ['😰', 'Peoples', ['cold_sweat']],
  ['😢', 'Peoples', ['cry']],
  ['😥', 'Peoples', ['disappointed_relieved']],
  ['🤤', 'Peoples', ['drooling_face']],
  ['😭', 'Peoples', ['sob']],
  ['😓', 'Peoples', ['sweat']],
  ['😪', 'Peoples', ['sleepy']],
  ['😴', 'Peoples', ['sleeping']],
  ['🙄', 'Peoples', ['roll_eyes']],
  ['🤔', 'Peoples', ['thinking']],
  ['🤥', 'Peoples', ['lying_face']],
  ['😬', 'Peoples', ['grimacing']],
  ['🤐', 'Peoples', ['zipper_mouth_face']],
  ['🤢', 'Peoples', ['nauseated_face']],
  ['🤧', 'Peoples', ['sneezing_face']],
  ['😷', 'Peoples', ['mask']],
  ['🤒', 'Peoples', ['face_with_thermometer']],
  ['🤕', 'Peoples', ['face_with_head_bandage']],
  ['😈', 'Peoples', ['smiling_imp']],
  ['👿', 'Peoples', ['imp']],
  ['👹', 'Peoples', ['japanese_ogre']],
  ['👺', 'Peoples', ['japanese_goblin']],
  ['💩', 'Peoples', ['hankey', 'poop', 'shit']],
  ['👻', 'Peoples', ['ghost']],
  ['💀', 'Peoples', ['skull']],
  ['☠️', 'Peoples', ['skull_and_crossbones']],
  ['👽', 'Peoples', ['alien']],
  ['👾', 'Peoples', ['space_invader']],
  ['🤖', 'Peoples', ['robot']],
  ['🎃', 'Peoples', ['jack_o_lantern']],
  ['😺', 'Peoples', ['smiley_cat']],
  ['😸', 'Peoples', ['smile_cat']],
  ['😹', 'Peoples', ['joy_cat']],
  ['😻', 'Peoples', ['heart_eyes_cat']],
  ['😼', 'Peoples', ['smirk_cat']],
  ['😽', 'Peoples', ['kissing_cat']],
  ['🙀', 'Peoples', ['scream_cat']],
  ['😿', 'Peoples', ['crying_cat_face']],
  ['😾', 'Peoples', ['pouting_cat']],
  ['👐', 'Peoples', ['open_hands']],
  ['🙌', 'Peoples', ['raised_hands']],
  ['👏', 'Peoples', ['clap']],
  ['🙏', 'Peoples', ['pray']],
  ['🤝', 'Peoples', ['handshake']],
  ['👍', 'Peoples', ['+1', 'thumbsup']],
  ['👎', 'Peoples', ['-1', 'thumbsdown']],
  ['👊', 'Peoples', ['fist_oncoming', 'facepunch', 'punch']],
  ['✊', 'Peoples', ['fist_raised', 'fist']],
  ['🤛', 'Peoples', ['fist_left']],
  ['🤜', 'Peoples', ['fist_right']],
  ['🤞', 'Peoples', ['crossed_fingers']],
  ['✌️', 'Peoples', ['v']],
  ['🤘', 'Peoples', ['metal']],
  ['👌', 'Peoples', ['ok_hand']],
  ['👈', 'Peoples', ['point_left']],
  ['👉', 'Peoples', ['point_right']],
  ['👆', 'Peoples', ['point_up_2']],
  ['👇', 'Peoples', ['point_down']],
  ['☝️', 'Peoples', ['point_up']],
  ['✋', 'Peoples', ['hand', 'raised_hand']],
  ['🤚', 'Peoples', ['raised_back_of_hand']],
  ['🖐', 'Peoples', ['raised_hand_with_fingers_splayed']],
  ['🖖', 'Peoples', ['vulcan_salute']],
  ['👋', 'Peoples', ['wave']],
  ['🤙', 'Peoples', ['call_me_hand']],
  ['💪', 'Peoples', ['muscle']],
  ['🖕', 'Peoples', ['middle_finger', 'fu']],
  ['✍️', 'Peoples', ['writing_hand']],
  ['🤳', 'Peoples', ['selfie']],
  ['💅', 'Peoples', ['nail_care']],
  ['💍', 'Peoples', ['ring']],
  ['💄', 'Peoples', ['lipstick']],
  ['💋', 'Peoples', ['kiss']],
  ['👄', 'Peoples', ['lips']],
  ['👅', 'Peoples', ['tongue']],
  ['👂', 'Peoples', ['ear']],
  ['👃', 'Peoples', ['nose']],
  ['👣', 'Peoples', ['footprints']],
  ['👁', 'Peoples', ['eye']],
  ['👀', 'Peoples', ['eyes']],
  ['🗣', 'Peoples', ['speaking_head']],
  ['👤', 'Peoples', ['bust_in_silhouette']],
  ['👥', 'Peoples', ['busts_in_silhouette']],
  ['👶', 'Peoples', ['baby']],
  ['👦', 'Peoples', ['boy']],
  ['👧', 'Peoples', ['girl']],
  ['👨', 'Peoples', ['man']],
  ['👩', 'Peoples', ['woman']],
  ['👱‍♀', 'Peoples', ['blonde_woman']],
  ['👱', 'Peoples', ['blonde_man', 'person_with_blond_hair']],
  ['👴', 'Peoples', ['older_man']],
  ['👵', 'Peoples', ['older_woman']],
  ['👲', 'Peoples', ['man_with_gua_pi_mao']],
  ['👳‍♀', 'Peoples', ['woman_with_turban']],
  ['👳', 'Peoples', ['man_with_turban']],
  ['👮‍♀', 'Peoples', ['policewoman']],
  ['👮', 'Peoples', ['policeman', 'cop']],
  ['👷‍♀', 'Peoples', ['construction_worker_woman']],
  ['👷', 'Peoples', ['construction_worker_man', 'construction_worker']],
  ['💂‍♀', 'Peoples', ['guardswoman']],
  ['💂', 'Peoples', ['guardsman']],
  ['👩‍⚕', 'Peoples', ['woman_health_worker']],
  ['👨‍⚕', 'Peoples', ['man_health_worker']],
  ['👩‍🌾', 'Peoples', ['woman_farmer']],
  ['👨‍🌾', 'Peoples', ['man_farmer']],
  ['👩‍🍳', 'Peoples', ['woman_cook']],
  ['👨‍🍳', 'Peoples', ['man_cook']],
  ['👩‍🎓', 'Peoples', ['woman_student']],
  ['👨‍🎓', 'Peoples', ['man_student']],
  ['👩‍🎤', 'Peoples', ['woman_singer']],
  ['👨‍🎤', 'Peoples', ['man_singer']],
  ['👩‍🏫', 'Peoples', ['woman_teacher']],
  ['👨‍🏫', 'Peoples', ['man_teacher']],
  ['👩‍🏭', 'Peoples', ['woman_factory_worker']],
  ['👨‍🏭', 'Peoples', ['man_factory_worker']],
  ['👩‍💻', 'Peoples', ['woman_technologist']],
  ['👨‍💻', 'Peoples', ['man_technologist']],
  ['👩‍💼', 'Peoples', ['woman_office_worker']],
  ['👨‍💼', 'Peoples', ['man_office_worker']],
  ['👩‍🔧', 'Peoples', ['woman_mechanic']],
  ['👨‍🔧', 'Peoples', ['man_mechanic']],
  ['👩‍🔬', 'Peoples', ['woman_scientist']],
  ['👨‍🔬', 'Peoples', ['man_scientist']],
  ['👩‍🎨', 'Peoples', ['woman_artist']],
  ['👨‍🎨', 'Peoples', ['man_artist']],
  ['👩‍🚒', 'Peoples', ['woman_firefighter']],
  ['👨‍🚒', 'Peoples', ['man_firefighter']],
  ['👩‍🚀', 'Peoples', ['woman_astronaut']],
  ['👨‍🚀', 'Peoples', ['man_astronaut']],
  ['🤶', 'Peoples', ['mrs_claus']],
  ['🎅', 'Peoples', ['santa']],
  ['👸', 'Peoples', ['princess']],
  ['🤴', 'Peoples', ['prince']],
  ['👰', 'Peoples', ['bride_with_veil']],
  ['🤵', 'Peoples', ['man_in_tuxedo']],
  ['👼', 'Peoples', ['angel']],
  ['🤰', 'Peoples', ['pregnant_woman']],
  ['🙇‍♀', 'Peoples', ['bowing_woman']],
  ['🙇', 'Peoples', ['bowing_man', 'bow']],
  ['💁', 'Peoples', ['tipping_hand_woman', 'information_desk_person', 'sassy_woman']],
  ['💁‍♂', 'Peoples', ['tipping_hand_man', 'sassy_man']],
  ['🙅', 'Peoples', ['no_good_woman', 'no_good', 'ng_woman']],
  ['🙅‍♂', 'Peoples', ['no_good_man', 'ng_man']],
  ['🙆', 'Peoples', ['ok_woman']],
  ['🙆‍♂', 'Peoples', ['ok_man']],
  ['🙋', 'Peoples', ['raising_hand_woman', 'raising_hand']],
  ['🙋‍♂', 'Peoples', ['raising_hand_man']],
  ['🤦‍♀', 'Peoples', ['woman_facepalming']],
  ['🤦‍♂', 'Peoples', ['man_facepalming']],
  ['🤷‍♀', 'Peoples', ['woman_shrugging']],
  ['🤷‍♂', 'Peoples', ['man_shrugging']],
  ['🙎', 'Peoples', ['pouting_woman', 'person_with_pouting_face']],
  ['🙎‍♂', 'Peoples', ['pouting_man']],
  ['🙍', 'Peoples', ['frowning_woman', 'person_frowning']],
  ['🙍‍♂', 'Peoples', ['frowning_man']],
  ['💇', 'Peoples', ['haircut_woman', 'haircut']],
  ['💇‍♂', 'Peoples', ['haircut_man']],
  ['💆', 'Peoples', ['massage_woman', 'massage']],
  ['💆‍♂', 'Peoples', ['massage_man']],
  ['🕴', 'Peoples', ['business_suit_levitating']],
  ['💃', 'Peoples', ['dancer']],
  ['🕺', 'Peoples', ['man_dancing']],
  ['👯', 'Peoples', ['dancing_women', 'dancers']],
  ['👯‍♂', 'Peoples', ['dancing_men']],
  ['🚶‍♀', 'Peoples', ['walking_woman']],
  ['🚶', 'Peoples', ['walking_man', 'walking']],
  ['🏃‍♀', 'Peoples', ['running_woman']],
  ['🏃', 'Peoples', ['running_man', 'runner', 'running']],
  ['👫', 'Peoples', ['couple']],
  ['👭', 'Peoples', ['two_women_holding_hands']],
  ['👬', 'Peoples', ['two_men_holding_hands']],
  ['💑', 'Peoples', ['couple_with_heart_woman_man', 'couple_with_heart']],
  ['👩‍❤️‍👩', 'Peoples', ['couple_with_heart_woman_woman']],
  ['👨‍❤️‍👨', 'Peoples', ['couple_with_heart_man_man']],
  ['💏', 'Peoples', ['couplekiss_man_woman']],
  ['👩‍❤️‍💋‍👩', 'Peoples', ['couplekiss_woman_woman']],
  ['👨‍❤️‍💋‍👨', 'Peoples', ['couplekiss_man_man']],
  ['👪', 'Peoples', ['family_man_woman_boy', 'family']],
  ['👨‍👩‍👧', 'Peoples', ['family_man_woman_girl']],
  ['👨‍👩‍👧‍👦', 'Peoples', ['family_man_woman_girl_boy']],
  ['👨‍👩‍👦‍👦', 'Peoples', ['family_man_woman_boy_boy']],
  ['👨‍👩‍👧‍👧', 'Peoples', ['family_man_woman_girl_girl']],
  ['👩‍👩‍👦', 'Peoples', ['family_woman_woman_boy']],
  ['👩‍👩‍👧', 'Peoples', ['family_woman_woman_girl']],
  ['👩‍👩‍👧‍👦', 'Peoples', ['family_woman_woman_girl_boy']],
  ['👩‍👩‍👦‍👦', 'Peoples', ['family_woman_woman_boy_boy']],
  ['👩‍👩‍👧‍👧', 'Peoples', ['family_woman_woman_girl_girl']],
  ['👨‍👨‍👦', 'Peoples', ['family_man_man_boy']],
  ['👨‍👨‍👧', 'Peoples', ['family_man_man_girl']],
  ['👨‍👨‍👧‍👦', 'Peoples', ['family_man_man_girl_boy']],
  ['👨‍👨‍👦‍👦', 'Peoples', ['family_man_man_boy_boy']],
  ['👨‍👨‍👧‍👧', 'Peoples', ['family_man_man_girl_girl']],
  ['👩‍👦', 'Peoples', ['family_woman_boy']],
  ['👩‍👧', 'Peoples', ['family_woman_girl']],
  ['👩‍👧‍👦', 'Peoples', ['family_woman_girl_boy']],
  ['👩‍👦‍👦', 'Peoples', ['family_woman_boy_boy']],
  ['👩‍👧‍👧', 'Peoples', ['family_woman_girl_girl']],
  ['👨‍👦', 'Peoples', ['family_man_boy']],
  ['👨‍👧', 'Peoples', ['family_man_girl']],
  ['👨‍👧‍👦', 'Peoples', ['family_man_girl_boy']],
  ['👨‍👦‍👦', 'Peoples', ['family_man_boy_boy']],
  ['👨‍👧‍👧', 'Peoples', ['family_man_girl_girl']],
  ['👚', 'Peoples', ['womans_clothes']],
  ['👕', 'Peoples', ['shirt', 'tshirt']],
  ['👖', 'Peoples', ['jeans']],
  ['👔', 'Peoples', ['necktie']],
  ['👗', 'Peoples', ['dress']],
  ['👙', 'Peoples', ['bikini']],
  ['👘', 'Peoples', ['kimono']],
  ['👠', 'Peoples', ['high_heel']],
  ['👡', 'Peoples', ['sandal']],
  ['👢', 'Peoples', ['boot']],
  ['👞', 'Peoples', ['mans_shoe', 'shoe']],
  ['👟', 'Peoples', ['athletic_shoe']],
  ['👒', 'Peoples', ['womans_hat']],
  ['🎩', 'Peoples', ['tophat']],
  ['🎓', 'Peoples', ['mortar_board']],
  ['👑', 'Peoples', ['crown']],
  ['⛑', 'Peoples', ['rescue_worker_helmet']],
  ['🎒', 'Peoples', ['school_satchel']],
  ['👝', 'Peoples', ['pouch']],
  ['👛', 'Peoples', ['purse']],
  ['👜', 'Peoples', ['handbag']],
  ['💼', 'Peoples', ['briefcase']],
  ['👓', 'Peoples', ['eyeglasses']],
  ['🕶', 'Peoples', ['dark_sunglasses']],
  ['🌂', 'Peoples', ['closed_umbrella']],
  ['☂️', 'Peoples', ['open_umbrella']],
  ['🐶', 'Nature', ['dog']],
  ['🐱', 'Nature', ['cat']],
  ['🐭', 'Nature', ['mouse']],
  ['🐹', 'Nature', ['hamster']],
  ['🐰', 'Nature', ['rabbit']],
  ['🦊', 'Nature', ['fox_face']],
  ['🐻', 'Nature', ['bear']],
  ['🐼', 'Nature', ['panda_face']],
  ['🐨', 'Nature', ['koala']],
  ['🐯', 'Nature', ['tiger']],
  ['🦁', 'Nature', ['lion']],
  ['🐮', 'Nature', ['cow']],
  ['🐷', 'Nature', ['pig']],
  ['🐽', 'Nature', ['pig_nose']],
  ['🐸', 'Nature', ['frog']],
  ['🐵', 'Nature', ['monkey_face']],
  ['🙈', 'Nature', ['see_no_evil']],
  ['🙉', 'Nature', ['hear_no_evil']],
  ['🙊', 'Nature', ['speak_no_evil']],
  ['🐒', 'Nature', ['monkey']],
  ['🐔', 'Nature', ['chicken']],
  ['🐧', 'Nature', ['penguin']],
  ['🐦', 'Nature', ['bird']],
  ['🐤', 'Nature', ['baby_chick']],
  ['🐣', 'Nature', ['hatching_chick']],
  ['🐥', 'Nature', ['hatched_chick']],
  ['🦆', 'Nature', ['duck']],
  ['🦅', 'Nature', ['eagle']],
  ['🦉', 'Nature', ['owl']],
  ['🦇', 'Nature', ['bat']],
  ['🐺', 'Nature', ['wolf']],
  ['🐗', 'Nature', ['boar']],
  ['🐴', 'Nature', ['horse']],
  ['🦄', 'Nature', ['unicorn']],
  ['🐝', 'Nature', ['bee', 'honeybee']],
  ['🐛', 'Nature', ['bug']],
  ['🦋', 'Nature', ['butterfly']],
  ['🐌', 'Nature', ['snail']],
  ['🐚', 'Nature', ['shell']],
  ['🐞', 'Nature', ['beetle']],
  ['🐜', 'Nature', ['ant']],
  ['🕷', 'Nature', ['spider']],
  ['🕸', 'Nature', ['spider_web']],
  ['🐢', 'Nature', ['turtle']],
  ['🐍', 'Nature', ['snake']],
  ['🦎', 'Nature', ['lizard']],
  ['🦂', 'Nature', ['scorpion']],
  ['🦀', 'Nature', ['crab']],
  ['🦑', 'Nature', ['squid']],
  ['🐙', 'Nature', ['octopus']],
  ['🦐', 'Nature', ['shrimp']],
  ['🐠', 'Nature', ['tropical_fish']],
  ['🐟', 'Nature', ['fish']],
  ['🐡', 'Nature', ['blowfish']],
  ['🐬', 'Nature', ['dolphin', 'flipper']],
  ['🦈', 'Nature', ['shark']],
  ['🐳', 'Nature', ['whale']],
  ['🐋', 'Nature', ['whale2']],
  ['🐊', 'Nature', ['crocodile']],
  ['🐆', 'Nature', ['leopard']],
  ['🐅', 'Nature', ['tiger2']],
  ['🐃', 'Nature', ['water_buffalo']],
  ['🐂', 'Nature', ['ox']],
  ['🐄', 'Nature', ['cow2']],
  ['🦌', 'Nature', ['deer']],
  ['🐪', 'Nature', ['dromedary_camel']],
  ['🐫', 'Nature', ['camel']],
  ['🐘', 'Nature', ['elephant']],
  ['🦏', 'Nature', ['rhinoceros']],
  ['🦍', 'Nature', ['gorilla']],
  ['🐎', 'Nature', ['racehorse']],
  ['🐖', 'Nature', ['pig2']],
  ['🐐', 'Nature', ['goat']],
  ['🐏', 'Nature', ['ram']],
  ['🐑', 'Nature', ['sheep']],
  ['🐕', 'Nature', ['dog2']],
  ['🐩', 'Nature', ['poodle']],
  ['🐈', 'Nature', ['cat2']],
  ['🐓', 'Nature', ['rooster']],
  ['🦃', 'Nature', ['turkey']],
  ['🕊', 'Nature', ['dove']],
  ['🐇', 'Nature', ['rabbit2']],
  ['🐁', 'Nature', ['mouse2']],
  ['🐀', 'Nature', ['rat']],
  ['🐿', 'Nature', ['chipmunk']],
  ['🐾', 'Nature', ['feet', 'paw_prints']],
  ['🐉', 'Nature', ['dragon']],
  ['🐲', 'Nature', ['dragon_face']],
  ['🌵', 'Nature', ['cactus']],
  ['🎄', 'Nature', ['christmas_tree']],
  ['🌲', 'Nature', ['evergreen_tree']],
  ['🌳', 'Nature', ['deciduous_tree']],
  ['🌴', 'Nature', ['palm_tree']],
  ['🌱', 'Nature', ['seedling']],
  ['🌿', 'Nature', ['herb']],
  ['☘️', 'Nature', ['shamrock']],
  ['🍀', 'Nature', ['four_leaf_clover']],
  ['🎍', 'Nature', ['bamboo']],
  ['🎋', 'Nature', ['tanabata_tree']],
  ['🍃', 'Nature', ['leaves']],
  ['🍂', 'Nature', ['fallen_leaf']],
  ['🍁', 'Nature', ['maple_leaf']],
  ['🍄', 'Nature', ['mushroom']],
  ['🌾', 'Nature', ['ear_of_rice']],
  ['💐', 'Nature', ['bouquet']],
  ['🌷', 'Nature', ['tulip']],
  ['🌹', 'Nature', ['rose']],
  ['🥀', 'Nature', ['wilted_flower']],
  ['🌻', 'Nature', ['sunflower']],
  ['🌼', 'Nature', ['blossom']],
  ['🌸', 'Nature', ['cherry_blossom']],
  ['🌺', 'Nature', ['hibiscus']],
  ['🌎', 'Nature', ['earth_americas']],
  ['🌍', 'Nature', ['earth_africa']],
  ['🌏', 'Nature', ['earth_asia']],
  ['🌕', 'Nature', ['full_moon']],
  ['🌖', 'Nature', ['waning_gibbous_moon']],
  ['🌗', 'Nature', ['last_quarter_moon']],
  ['🌘', 'Nature', ['waning_crescent_moon']],
  ['🌑', 'Nature', ['new_moon']],
  ['🌒', 'Nature', ['waxing_crescent_moon']],
  ['🌓', 'Nature', ['first_quarter_moon']],
  ['🌔', 'Nature', ['moon', 'waxing_gibbous_moon']],
  ['🌚', 'Nature', ['new_moon_with_face']],
  ['🌝', 'Nature', ['full_moon_with_face']],
  ['🌞', 'Nature', ['sun_with_face']],
  ['🌛', 'Nature', ['first_quarter_moon_with_face']],
  ['🌜', 'Nature', ['last_quarter_moon_with_face']],
  ['🌙', 'Nature', ['crescent_moon']],
  ['💫', 'Nature', ['dizzy']],
  ['⭐️', 'Nature', ['star']],
  ['🌟', 'Nature', ['star2']],
  ['✨', 'Nature', ['sparkles']],
  ['⚡️', 'Nature', ['zap']],
  ['🔥', 'Nature', ['fire']],
  ['💥', 'Nature', ['boom', 'collision']],
  ['☄', 'Nature', ['comet']],
  ['☀️', 'Nature', ['sunny']],
  ['🌤', 'Nature', ['sun_behind_small_cloud']],
  ['⛅️', 'Nature', ['partly_sunny']],
  ['🌥', 'Nature', ['sun_behind_large_cloud']],
  ['🌦', 'Nature', ['sun_behind_rain_cloud']],
  ['🌈', 'Nature', ['rainbow']],
  ['☁️', 'Nature', ['cloud']],
  ['🌧', 'Nature', ['cloud_with_rain']],
  ['⛈', 'Nature', ['cloud_with_lightning_and_rain']],
  ['🌩', 'Nature', ['cloud_with_lightning']],
  ['🌨', 'Nature', ['cloud_with_snow']],
  ['☃️', 'Nature', ['snowman_with_snow']],
  ['⛄️', 'Nature', ['snowman']],
  ['❄️', 'Nature', ['snowflake']],
  ['🌬', 'Nature', ['wind_face']],
  ['💨', 'Nature', ['dash']],
  ['🌪', 'Nature', ['tornado']],
  ['🌫', 'Nature', ['fog']],
  ['🌊', 'Nature', ['ocean']],
  ['💧', 'Nature', ['droplet']],
  ['💦', 'Nature', ['sweat_drops']],
  ['☔️', 'Nature', ['umbrella']],
  ['🍏', 'Foods', ['green_apple']],
  ['🍎', 'Foods', ['apple']],
  ['🍐', 'Foods', ['pear']],
  ['🍊', 'Foods', ['tangerine', 'orange', 'mandarin']],
  ['🍋', 'Foods', ['lemon']],
  ['🍌', 'Foods', ['banana']],
  ['🍉', 'Foods', ['watermelon']],
  ['🍇', 'Foods', ['grapes']],
  ['🍓', 'Foods', ['strawberry']],
  ['🍈', 'Foods', ['melon']],
  ['🍒', 'Foods', ['cherries']],
  ['🍑', 'Foods', ['peach']],
  ['🍍', 'Foods', ['pineapple']],
  ['🥝', 'Foods', ['kiwi_fruit']],
  ['🥑', 'Foods', ['avocado']],
  ['🍅', 'Foods', ['tomato']],
  ['🍆', 'Foods', ['eggplant']],
  ['🥒', 'Foods', ['cucumber']],
  ['🥕', 'Foods', ['carrot']],
  ['🌽', 'Foods', ['corn']],
  ['🌶', 'Foods', ['hot_pepper']],
  ['🥔', 'Foods', ['potato']],
  ['🍠', 'Foods', ['sweet_potato']],
  ['🌰', 'Foods', ['chestnut']],
  ['🥜', 'Foods', ['peanuts']],
  ['🍯', 'Foods', ['honey_pot']],
  ['🥐', 'Foods', ['croissant']],
  ['🍞', 'Foods', ['bread']],
  ['🥖', 'Foods', ['baguette_bread']],
  ['🧀', 'Foods', ['cheese']],
  ['🥚', 'Foods', ['egg']],
  ['🍳', 'Foods', ['fried_egg']],
  ['🥓', 'Foods', ['bacon']],
  ['🥞', 'Foods', ['pancakes']],
  ['🍤', 'Foods', ['fried_shrimp']],
  ['🍗', 'Foods', ['poultry_leg']],
  ['🍖', 'Foods', ['meat_on_bone']],
  ['🍕', 'Foods', ['pizza']],
  ['🌭', 'Foods', ['hotdog']],
  ['🍔', 'Foods', ['hamburger']],
  ['🍟', 'Foods', ['fries']],
  ['🥙', 'Foods', ['stuffed_flatbread']],
  ['🌮', 'Foods', ['taco']],
  ['🌯', 'Foods', ['burrito']],
  ['🥗', 'Foods', ['green_salad']],
  ['🥘', 'Foods', ['shallow_pan_of_food']],
  ['🍝', 'Foods', ['spaghetti']],
  ['🍜', 'Foods', ['ramen']],
  ['🍲', 'Foods', ['stew']],
  ['🍥', 'Foods', ['fish_cake']],
  ['🍣', 'Foods', ['sushi']],
  ['🍱', 'Foods', ['bento']],
  ['🍛', 'Foods', ['curry']],
  ['🍚', 'Foods', ['rice']],
  ['🍙', 'Foods', ['rice_ball']],
  ['🍘', 'Foods', ['rice_cracker']],
  ['🍢', 'Foods', ['oden']],
  ['🍡', 'Foods', ['dango']],
  ['🍧', 'Foods', ['shaved_ice']],
  ['🍨', 'Foods', ['ice_cream']],
  ['🍦', 'Foods', ['icecream']],
  ['🍰', 'Foods', ['cake']],
  ['🎂', 'Foods', ['birthday']],
  ['🍮', 'Foods', ['custard']],
  ['🍭', 'Foods', ['lollipop']],
  ['🍬', 'Foods', ['candy']],
  ['🍫', 'Foods', ['chocolate_bar']],
  ['🍿', 'Foods', ['popcorn']],
  ['🍩', 'Foods', ['doughnut']],
  ['🍪', 'Foods', ['cookie']],
  ['🥛', 'Foods', ['milk_glass']],
  ['🍼', 'Foods', ['baby_bottle']],
  ['☕️', 'Foods', ['coffee']],
  ['🍵', 'Foods', ['tea']],
  ['🍶', 'Foods', ['sake']],
  ['🍺', 'Foods', ['beer']],
  ['🍻', 'Foods', ['beers']],
  ['🥂', 'Foods', ['clinking_glasses']],
  ['🍷', 'Foods', ['wine_glass']],
  ['🥃', 'Foods', ['tumbler_glass']],
  ['🍸', 'Foods', ['cocktail']],
  ['🍹', 'Foods', ['tropical_drink']],
  ['🍾', 'Foods', ['champagne']],
  ['🥄', 'Foods', ['spoon']],
  ['🍴', 'Foods', ['fork_and_knife']],
  ['🍽', 'Foods', ['plate_with_cutlery']],
  ['⚽️', 'Activity', ['soccer']],
  ['🏀', 'Activity', ['basketball']],
  ['🏈', 'Activity', ['football']],
  ['⚾️', 'Activity', ['baseball']],
  ['🎾', 'Activity', ['tennis']],
  ['🏐', 'Activity', ['volleyball']],
  ['🏉', 'Activity', ['rugby_football']],
  ['🎱', 'Activity', ['8ball']],
  ['🏓', 'Activity', ['ping_pong']],
  ['🏸', 'Activity', ['badminton']],
  ['🥅', 'Activity', ['goal_net']],
  ['🏒', 'Activity', ['ice_hockey']],
  ['🏑', 'Activity', ['field_hockey']],
  ['🏏', 'Activity', ['cricket']],
  ['⛳️', 'Activity', ['golf']],
  ['🏹', 'Activity', ['bow_and_arrow']],
  ['🎣', 'Activity', ['fishing_pole_and_fish']],
  ['🥊', 'Activity', ['boxing_glove']],
  ['🥋', 'Activity', ['martial_arts_uniform']],
  ['⛸', 'Activity', ['ice_skate']],
  ['🎿', 'Activity', ['ski']],
  ['⛷', 'Activity', ['skier']],
  ['🏂', 'Activity', ['snowboarder']],
  ['🏋️‍♀️', 'Activity', ['weight_lifting_woman']],
  ['🏋', 'Activity', ['weight_lifting_man']],
  ['🤺', 'Activity', ['person_fencing']],
  ['🤼‍♀', 'Activity', ['women_wrestling']],
  ['🤼‍♂', 'Activity', ['men_wrestling']],
  ['🤸‍♀', 'Activity', ['woman_cartwheeling']],
  ['🤸‍♂', 'Activity', ['man_cartwheeling']],
  ['⛹️‍♀️', 'Activity', ['basketball_woman']],
  ['⛹', 'Activity', ['basketball_man']],
  ['🤾‍♀', 'Activity', ['woman_playing_handball']],
  ['🤾‍♂', 'Activity', ['man_playing_handball']],
  ['🏌️‍♀️', 'Activity', ['golfing_woman']],
  ['🏌', 'Activity', ['golfing_man']],
  ['🏄‍♀', 'Activity', ['surfing_woman']],
  ['🏄', 'Activity', ['surfing_man', 'surfer']],
  ['🏊‍♀', 'Activity', ['swimming_woman']],
  ['🏊', 'Activity', ['swimming_man', 'swimmer']],
  ['🤽‍♀', 'Activity', ['woman_playing_water_polo']],
  ['🤽‍♂', 'Activity', ['man_playing_water_polo']],
  ['🚣‍♀', 'Activity', ['rowing_woman']],
  ['🚣', 'Activity', ['rowing_man', 'rowboat']],
  ['🏇', 'Activity', ['horse_racing']],
  ['🚴‍♀', 'Activity', ['biking_woman']],
  ['🚴', 'Activity', ['biking_man', 'bicyclist']],
  ['🚵‍♀', 'Activity', ['mountain_biking_woman']],
  ['🚵', 'Activity', ['mountain_biking_man', 'mountain_bicyclist']],
  ['🎽', 'Activity', ['running_shirt_with_sash']],
  ['🏅', 'Activity', ['medal_sports']],
  ['🎖', 'Activity', ['medal_military']],
  ['🥇', 'Activity', ['1st_place_medal']],
  ['🥈', 'Activity', ['2nd_place_medal']],
  ['🥉', 'Activity', ['3rd_place_medal']],
  ['🏆', 'Activity', ['trophy']],
  ['🏵', 'Activity', ['rosette']],
  ['🎗', 'Activity', ['reminder_ribbon']],
  ['🎫', 'Activity', ['ticket']],
  ['🎟', 'Activity', ['tickets']],
  ['🎪', 'Activity', ['circus_tent']],
  ['🤹‍♀', 'Activity', ['woman_juggling']],
  ['🤹‍♂', 'Activity', ['man_juggling']],
  ['🎭', 'Activity', ['performing_arts']],
  ['🎨', 'Activity', ['art']],
  ['🎬', 'Activity', ['clapper']],
  ['🎤', 'Activity', ['microphone']],
  ['🎧', 'Activity', ['headphones']],
  ['🎼', 'Activity', ['musical_score']],
  ['🎹', 'Activity', ['musical_keyboard']],
  ['🥁', 'Activity', ['drum']],
  ['🎷', 'Activity', ['saxophone']],
  ['🎺', 'Activity', ['trumpet']],
  ['🎸', 'Activity', ['guitar']],
  ['🎻', 'Activity', ['violin']],
  ['🎲', 'Activity', ['game_die']],
  ['🎯', 'Activity', ['dart']],
  ['🎳', 'Activity', ['bowling']],
  ['🎮', 'Activity', ['video_game']],
  ['🎰', 'Activity', ['slot_machine']],
  ['🚗', 'Places', ['car', 'red_car']],
  ['🚕', 'Places', ['taxi']],
  ['🚙', 'Places', ['blue_car']],
  ['🚌', 'Places', ['bus']],
  ['🚎', 'Places', ['trolleybus']],
  ['🏎', 'Places', ['racing_car']],
  ['🚓', 'Places', ['police_car']],
  ['🚑', 'Places', ['ambulance']],
  ['🚒', 'Places', ['fire_engine']],
  ['🚐', 'Places', ['minibus']],
  ['🚚', 'Places', ['truck']],
  ['🚛', 'Places', ['articulated_lorry']],
  ['🚜', 'Places', ['tractor']],
  ['🛴', 'Places', ['kick_scooter']],
  ['🚲', 'Places', ['bike']],
  ['🛵', 'Places', ['motor_scooter']],
  ['🏍', 'Places', ['motorcycle']],
  ['🚨', 'Places', ['rotating_light']],
  ['🚔', 'Places', ['oncoming_police_car']],
  ['🚍', 'Places', ['oncoming_bus']],
  ['🚘', 'Places', ['oncoming_automobile']],
  ['🚖', 'Places', ['oncoming_taxi']],
  ['🚡', 'Places', ['aerial_tramway']],
  ['🚠', 'Places', ['mountain_cableway']],
  ['🚟', 'Places', ['suspension_railway']],
  ['🚃', 'Places', ['railway_car']],
  ['🚋', 'Places', ['train']],
  ['🚞', 'Places', ['mountain_railway']],
  ['🚝', 'Places', ['monorail']],
  ['🚄', 'Places', ['bullettrain_side']],
  ['🚅', 'Places', ['bullettrain_front']],
  ['🚈', 'Places', ['light_rail']],
  ['🚂', 'Places', ['steam_locomotive']],
  ['🚆', 'Places', ['train2']],
  ['🚇', 'Places', ['metro']],
  ['🚊', 'Places', ['tram']],
  ['🚉', 'Places', ['station']],
  ['🚁', 'Places', ['helicopter']],
  ['🛩', 'Places', ['small_airplane']],
  ['✈️', 'Places', ['airplane']],
  ['🛫', 'Places', ['flight_departure']],
  ['🛬', 'Places', ['flight_arrival']],
  ['🚀', 'Places', ['rocket']],
  ['🛰', 'Places', ['artificial_satellite']],
  ['💺', 'Places', ['seat']],
  ['🛶', 'Places', ['canoe']],
  ['⛵️', 'Places', ['boat', 'sailboat']],
  ['🛥', 'Places', ['motor_boat']],
  ['🚤', 'Places', ['speedboat']],
  ['🛳', 'Places', ['passenger_ship']],
  ['⛴', 'Places', ['ferry']],
  ['🚢', 'Places', ['ship']],
  ['⚓️', 'Places', ['anchor']],
  ['🚧', 'Places', ['construction']],
  ['⛽️', 'Places', ['fuelpump']],
  ['🚏', 'Places', ['busstop']],
  ['🚦', 'Places', ['vertical_traffic_light']],
  ['🚥', 'Places', ['traffic_light']],
  ['🗺', 'Places', ['world_map']],
  ['🗿', 'Places', ['moyai']],
  ['🗽', 'Places', ['statue_of_liberty']],
  ['⛲️', 'Places', ['fountain']],
  ['🗼', 'Places', ['tokyo_tower']],
  ['🏰', 'Places', ['european_castle']],
  ['🏯', 'Places', ['japanese_castle']],
  ['🏟', 'Places', ['stadium']],
  ['🎡', 'Places', ['ferris_wheel']],
  ['🎢', 'Places', ['roller_coaster']],
  ['🎠', 'Places', ['carousel_horse']],
  ['⛱', 'Places', ['parasol_on_ground']],
  ['🏖', 'Places', ['beach_umbrella']],
  ['🏝', 'Places', ['desert_island']],
  ['⛰', 'Places', ['mountain']],
  ['🏔', 'Places', ['mountain_snow']],
  ['🗻', 'Places', ['mount_fuji']],
  ['🌋', 'Places', ['volcano']],
  ['🏜', 'Places', ['desert']],
  ['🏕', 'Places', ['camping']],
  ['⛺️', 'Places', ['tent']],
  ['🛤', 'Places', ['railway_track']],
  ['🛣', 'Places', ['motorway']],
  ['🏗', 'Places', ['building_construction']],
  ['🏭', 'Places', ['factory']],
  ['🏠', 'Places', ['house']],
  ['🏡', 'Places', ['house_with_garden']],
  ['🏘', 'Places', ['houses']],
  ['🏚', 'Places', ['derelict_house']],
  ['🏢', 'Places', ['office']],
  ['🏬', 'Places', ['department_store']],
  ['🏣', 'Places', ['post_office']],
  ['🏤', 'Places', ['european_post_office']],
  ['🏥', 'Places', ['hospital']],
  ['🏦', 'Places', ['bank']],
  ['🏨', 'Places', ['hotel']],
  ['🏪', 'Places', ['convenience_store']],
  ['🏫', 'Places', ['school']],
  ['🏩', 'Places', ['love_hotel']],
  ['💒', 'Places', ['wedding']],
  ['🏛', 'Places', ['classical_building']],
  ['⛪️', 'Places', ['church']],
  ['🕌', 'Places', ['mosque']],
  ['🕍', 'Places', ['synagogue']],
  ['🕋', 'Places', ['kaaba']],
  ['⛩', 'Places', ['shinto_shrine']],
  ['🗾', 'Places', ['japan']],
  ['🎑', 'Places', ['rice_scene']],
  ['🏞', 'Places', ['national_park']],
  ['🌅', 'Places', ['sunrise']],
  ['🌄', 'Places', ['sunrise_over_mountains']],
  ['🌠', 'Places', ['stars']],
  ['🎇', 'Places', ['sparkler']],
  ['🎆', 'Places', ['fireworks']],
  ['🌇', 'Places', ['city_sunrise']],
  ['🌆', 'Places', ['city_sunset']],
  ['🏙', 'Places', ['cityscape']],
  ['🌃', 'Places', ['night_with_stars']],
  ['🌌', 'Places', ['milky_way']],
  ['🌉', 'Places', ['bridge_at_night']],
  ['🌁', 'Places', ['foggy']],
  ['⌚️', 'Objects', ['watch']],
  ['📱', 'Objects', ['iphone']],
  ['📲', 'Objects', ['calling']],
  ['💻', 'Objects', ['computer']],
  ['⌨️', 'Objects', ['keyboard']],
  ['🖥', 'Objects', ['desktop_computer']],
  ['🖨', 'Objects', ['printer']],
  ['🖱', 'Objects', ['computer_mouse']],
  ['🖲', 'Objects', ['trackball']],
  ['🕹', 'Objects', ['joystick']],
  ['🗜', 'Objects', ['clamp']],
  ['💽', 'Objects', ['minidisc']],
  ['💾', 'Objects', ['floppy_disk']],
  ['💿', 'Objects', ['cd']],
  ['📀', 'Objects', ['dvd']],
  ['📼', 'Objects', ['vhs']],
  ['📷', 'Objects', ['camera']],
  ['📸', 'Objects', ['camera_flash']],
  ['📹', 'Objects', ['video_camera']],
  ['🎥', 'Objects', ['movie_camera']],
  ['📽', 'Objects', ['film_projector']],
  ['🎞', 'Objects', ['film_strip']],
  ['📞', 'Objects', ['telephone_receiver']],
  ['☎️', 'Objects', ['phone', 'telephone']],
  ['📟', 'Objects', ['pager']],
  ['📠', 'Objects', ['fax']],
  ['📺', 'Objects', ['tv']],
  ['📻', 'Objects', ['radio']],
  ['🎙', 'Objects', ['studio_microphone']],
  ['🎚', 'Objects', ['level_slider']],
  ['🎛', 'Objects', ['control_knobs']],
  ['⏱', 'Objects', ['stopwatch']],
  ['⏲', 'Objects', ['timer_clock']],
  ['⏰', 'Objects', ['alarm_clock']],
  ['🕰', 'Objects', ['mantelpiece_clock']],
  ['⌛️', 'Objects', ['hourglass']],
  ['⏳', 'Objects', ['hourglass_flowing_sand']],
  ['📡', 'Objects', ['satellite']],
  ['🔋', 'Objects', ['battery']],
  ['🔌', 'Objects', ['electric_plug']],
  ['💡', 'Objects', ['bulb']],
  ['🔦', 'Objects', ['flashlight']],
  ['🕯', 'Objects', ['candle']],
  ['🗑', 'Objects', ['wastebasket']],
  ['🛢', 'Objects', ['oil_drum']],
  ['💸', 'Objects', ['money_with_wings']],
  ['💵', 'Objects', ['dollar']],
  ['💴', 'Objects', ['yen']],
  ['💶', 'Objects', ['euro']],
  ['💷', 'Objects', ['pound']],
  ['💰', 'Objects', ['moneybag']],
  ['💳', 'Objects', ['credit_card']],
  ['💎', 'Objects', ['gem']],
  ['⚖️', 'Objects', ['balance_scale']],
  ['🔧', 'Objects', ['wrench']],
  ['🔨', 'Objects', ['hammer']],
  ['⚒', 'Objects', ['hammer_and_pick']],
  ['🛠', 'Objects', ['hammer_and_wrench']],
  ['⛏', 'Objects', ['pick']],
  ['🔩', 'Objects', ['nut_and_bolt']],
  ['⚙️', 'Objects', ['gear']],
  ['⛓', 'Objects', ['chains']],
  ['🔫', 'Objects', ['gun']],
  ['💣', 'Objects', ['bomb']],
  ['🔪', 'Objects', ['hocho', 'knife']],
  ['🗡', 'Objects', ['dagger']],
  ['⚔️', 'Objects', ['crossed_swords']],
  ['🛡', 'Objects', ['shield']],
  ['🚬', 'Objects', ['smoking']],
  ['⚰️', 'Objects', ['coffin']],
  ['⚱️', 'Objects', ['funeral_urn']],
  ['🏺', 'Objects', ['amphora']],
  ['🔮', 'Objects', ['crystal_ball']],
  ['📿', 'Objects', ['prayer_beads']],
  ['💈', 'Objects', ['barber']],
  ['⚗️', 'Objects', ['alembic']],
  ['🔭', 'Objects', ['telescope']],
  ['🔬', 'Objects', ['microscope']],
  ['🕳', 'Objects', ['hole']],
  ['💊', 'Objects', ['pill']],
  ['💉', 'Objects', ['syringe']],
  ['🌡', 'Objects', ['thermometer']],
  ['🚽', 'Objects', ['toilet']],
  ['🚰', 'Objects', ['potable_water']],
  ['🚿', 'Objects', ['shower']],
  ['🛁', 'Objects', ['bathtub']],
  ['🛀', 'Objects', ['bath']],
  ['🛎', 'Objects', ['bellhop_bell']],
  ['🔑', 'Objects', ['key']],
  ['🗝', 'Objects', ['old_key']],
  ['🚪', 'Objects', ['door']],
  ['🛋', 'Objects', ['couch_and_lamp']],
  ['🛏', 'Objects', ['bed']],
  ['🛌', 'Objects', ['sleeping_bed']],
  ['🖼', 'Objects', ['framed_picture']],
  ['🛍', 'Objects', ['shopping']],
  ['🛒', 'Objects', ['shopping_cart']],
  ['🎁', 'Objects', ['gift']],
  ['🎈', 'Objects', ['balloon']],
  ['🎏', 'Objects', ['flags']],
  ['🎀', 'Objects', ['ribbon']],
  ['🎊', 'Objects', ['confetti_ball']],
  ['🎉', 'Objects', ['tada']],
  ['🎎', 'Objects', ['dolls']],
  ['🏮', 'Objects', ['izakaya_lantern', 'lantern']],
  ['🎐', 'Objects', ['wind_chime']],
  ['✉️', 'Objects', ['email', 'envelope']],
  ['📩', 'Objects', ['envelope_with_arrow']],
  ['📨', 'Objects', ['incoming_envelope']],
  ['📧', 'Objects', ['e-mail']],
  ['💌', 'Objects', ['love_letter']],
  ['📥', 'Objects', ['inbox_tray']],
  ['📤', 'Objects', ['outbox_tray']],
  ['📦', 'Objects', ['package']],
  ['🏷', 'Objects', ['label']],
  ['📪', 'Objects', ['mailbox_closed']],
  ['📫', 'Objects', ['mailbox']],
  ['📬', 'Objects', ['mailbox_with_mail']],
  ['📭', 'Objects', ['mailbox_with_no_mail']],
  ['📮', 'Objects', ['postbox']],
  ['📯', 'Objects', ['postal_horn']],
  ['📜', 'Objects', ['scroll']],
  ['📃', 'Objects', ['page_with_curl']],
  ['📄', 'Objects', ['page_facing_up']],
  ['📑', 'Objects', ['bookmark_tabs']],
  ['📊', 'Objects', ['bar_chart']],
  ['📈', 'Objects', ['chart_with_upwards_trend']],
  ['📉', 'Objects', ['chart_with_downwards_trend']],
  ['🗒', 'Objects', ['spiral_notepad']],
  ['🗓', 'Objects', ['spiral_calendar']],
  ['📆', 'Objects', ['calendar']],
  ['📅', 'Objects', ['date']],
  ['📇', 'Objects', ['card_index']],
  ['🗃', 'Objects', ['card_file_box']],
  ['🗳', 'Objects', ['ballot_box']],
  ['🗄', 'Objects', ['file_cabinet']],
  ['📋', 'Objects', ['clipboard']],
  ['📁', 'Objects', ['file_folder']],
  ['📂', 'Objects', ['open_file_folder']],
  ['🗂', 'Objects', ['card_index_dividers']],
  ['🗞', 'Objects', ['newspaper_roll']],
  ['📰', 'Objects', ['newspaper']],
  ['📓', 'Objects', ['notebook']],
  ['📔', 'Objects', ['notebook_with_decorative_cover']],
  ['📒', 'Objects', ['ledger']],
  ['📕', 'Objects', ['closed_book']],
  ['📗', 'Objects', ['green_book']],
  ['📘', 'Objects', ['blue_book']],
  ['📙', 'Objects', ['orange_book']],
  ['📚', 'Objects', ['books']],
  ['📖', 'Objects', ['book', 'open_book']],
  ['🔖', 'Objects', ['bookmark']],
  ['🔗', 'Objects', ['link']],
  ['📎', 'Objects', ['paperclip']],
  ['🖇', 'Objects', ['paperclips']],
  ['📐', 'Objects', ['triangular_ruler']],
  ['📏', 'Objects', ['straight_ruler']],
  ['📌', 'Objects', ['pushpin']],
  ['📍', 'Objects', ['round_pushpin']],
  ['✂️', 'Objects', ['scissors']],
  ['🖊', 'Objects', ['pen']],
  ['🖋', 'Objects', ['fountain_pen']],
  ['✒️', 'Objects', ['black_nib']],
  ['🖌', 'Objects', ['paintbrush']],
  ['🖍', 'Objects', ['crayon']],
  ['📝', 'Objects', ['memo', 'pencil']],
  ['✏️', 'Objects', ['pencil2']],
  ['🔍', 'Objects', ['mag']],
  ['🔎', 'Objects', ['mag_right']],
  ['🔏', 'Objects', ['lock_with_ink_pen']],
  ['🔐', 'Objects', ['closed_lock_with_key']],
  ['🔒', 'Objects', ['lock']],
  ['🔓', 'Objects', ['unlock']],
  ['❤️', 'Symbols', ['heart']],
  ['💛', 'Symbols', ['yellow_heart']],
  ['💚', 'Symbols', ['green_heart']],
  ['💙', 'Symbols', ['blue_heart']],
  ['💜', 'Symbols', ['purple_heart']],
  ['🖤', 'Symbols', ['black_heart']],
  ['💔', 'Symbols', ['broken_heart']],
  ['❣️', 'Symbols', ['heavy_heart_exclamation']],
  ['💕', 'Symbols', ['two_hearts']],
  ['💞', 'Symbols', ['revolving_hearts']],
  ['💓', 'Symbols', ['heartbeat']],
  ['💗', 'Symbols', ['heartpulse']],
  ['💖', 'Symbols', ['sparkling_heart']],
  ['💘', 'Symbols', ['cupid']],
  ['💝', 'Symbols', ['gift_heart']],
  ['💟', 'Symbols', ['heart_decoration']],
  ['☮️', 'Symbols', ['peace_symbol']],
  ['✝️', 'Symbols', ['latin_cross']],
  ['☪️', 'Symbols', ['star_and_crescent']],
  ['🕉', 'Symbols', ['om']],
  ['☸️', 'Symbols', ['wheel_of_dharma']],
  ['✡️', 'Symbols', ['star_of_david']],
  ['🔯', 'Symbols', ['six_pointed_star']],
  ['🕎', 'Symbols', ['menorah']],
  ['☯️', 'Symbols', ['yin_yang']],
  ['☦️', 'Symbols', ['orthodox_cross']],
  ['🛐', 'Symbols', ['place_of_worship']],
  ['⛎', 'Symbols', ['ophiuchus']],
  ['♈️', 'Symbols', ['aries']],
  ['♉️', 'Symbols', ['taurus']],
  ['♊️', 'Symbols', ['gemini']],
  ['♋️', 'Symbols', ['cancer']],
  ['♌️', 'Symbols', ['leo']],
  ['♍️', 'Symbols', ['virgo']],
  ['♎️', 'Symbols', ['libra']],
  ['♏️', 'Symbols', ['scorpius']],
  ['♐️', 'Symbols', ['sagittarius']],
  ['♑️', 'Symbols', ['capricorn']],
  ['♒️', 'Symbols', ['aquarius']],
  ['♓️', 'Symbols', ['pisces']],
  ['🆔', 'Symbols', ['id']],
  ['⚛️', 'Symbols', ['atom_symbol']],
  ['🉑', 'Symbols', ['accept']],
  ['☢️', 'Symbols', ['radioactive']],
  ['☣️', 'Symbols', ['biohazard']],
  ['📴', 'Symbols', ['mobile_phone_off']],
  ['📳', 'Symbols', ['vibration_mode']],
  ['🈶', 'Symbols', ['u6709']],
  ['🈚️', 'Symbols', ['u7121']],
  ['🈸', 'Symbols', ['u7533']],
  ['🈺', 'Symbols', ['u55b6']],
  ['🈷️', 'Symbols', ['u6708']],
  ['✴️', 'Symbols', ['eight_pointed_black_star']],
  ['🆚', 'Symbols', ['vs']],
  ['💮', 'Symbols', ['white_flower']],
  ['🉐', 'Symbols', ['ideograph_advantage']],
  ['㊙️', 'Symbols', ['secret']],
  ['㊗️', 'Symbols', ['congratulations']],
  ['🈴', 'Symbols', ['u5408']],
  ['🈵', 'Symbols', ['u6e80']],
  ['🈹', 'Symbols', ['u5272']],
  ['🈲', 'Symbols', ['u7981']],
  ['🅰️', 'Symbols', ['a']],
  ['🅱️', 'Symbols', ['b']],
  ['🆎', 'Symbols', ['ab']],
  ['🆑', 'Symbols', ['cl']],
  ['🅾️', 'Symbols', ['o2']],
  ['🆘', 'Symbols', ['sos']],
  ['❌', 'Symbols', ['x']],
  ['⭕️', 'Symbols', ['o']],
  ['🛑', 'Symbols', ['stop_sign']],
  ['⛔️', 'Symbols', ['no_entry']],
  ['📛', 'Symbols', ['name_badge']],
  ['🚫', 'Symbols', ['no_entry_sign']],
  ['💯', 'Symbols', ['100']],
  ['💢', 'Symbols', ['anger']],
  ['♨️', 'Symbols', ['hotsprings']],
  ['🚷', 'Symbols', ['no_pedestrians']],
  ['🚯', 'Symbols', ['do_not_litter']],
  ['🚳', 'Symbols', ['no_bicycles']],
  ['🚱', 'Symbols', ['non-potable_water']],
  ['🔞', 'Symbols', ['underage']],
  ['📵', 'Symbols', ['no_mobile_phones']],
  ['🚭', 'Symbols', ['no_smoking']],
  ['❗️', 'Symbols', ['exclamation', 'heavy_exclamation_mark']],
  ['❕', 'Symbols', ['grey_exclamation']],
  ['❓', 'Symbols', ['question']],
  ['❔', 'Symbols', ['grey_question']],
  ['‼️', 'Symbols', ['bangbang']],
  ['⁉️', 'Symbols', ['interrobang']],
  ['🔅', 'Symbols', ['low_brightness']],
  ['🔆', 'Symbols', ['high_brightness']],
  ['〽️', 'Symbols', ['part_alternation_mark']],
  ['⚠️', 'Symbols', ['warning']],
  ['🚸', 'Symbols', ['children_crossing']],
  ['🔱', 'Symbols', ['trident']],
  ['⚜️', 'Symbols', ['fleur_de_lis']],
  ['🔰', 'Symbols', ['beginner']],
  ['♻️', 'Symbols', ['recycle']],
  ['✅', 'Symbols', ['white_check_mark']],
  ['🈯️', 'Symbols', ['u6307']],
  ['💹', 'Symbols', ['chart']],
  ['❇️', 'Symbols', ['sparkle']],
  ['✳️', 'Symbols', ['eight_spoked_asterisk']],
  ['❎', 'Symbols', ['negative_squared_cross_mark']],
  ['🌐', 'Symbols', ['globe_with_meridians']],
  ['💠', 'Symbols', ['diamond_shape_with_a_dot_inside']],
  ['Ⓜ️', 'Symbols', ['m']],
  ['🌀', 'Symbols', ['cyclone']],
  ['💤', 'Symbols', ['zzz']],
  ['🏧', 'Symbols', ['atm']],
  ['🚾', 'Symbols', ['wc']],
  ['♿️', 'Symbols', ['wheelchair']],
  ['🅿️', 'Symbols', ['parking']],
  ['🈳', 'Symbols', ['u7a7a']],
  ['🈂️', 'Symbols', ['sa']],
  ['🛂', 'Symbols', ['passport_control']],
  ['🛃', 'Symbols', ['customs']],
  ['🛄', 'Symbols', ['baggage_claim']],
  ['🛅', 'Symbols', ['left_luggage']],
  ['🚹', 'Symbols', ['mens']],
  ['🚺', 'Symbols', ['womens']],
  ['🚼', 'Symbols', ['baby_symbol']],
  ['🚻', 'Symbols', ['restroom']],
  ['🚮', 'Symbols', ['put_litter_in_its_place']],
  ['🎦', 'Symbols', ['cinema']],
  ['📶', 'Symbols', ['signal_strength']],
  ['🈁', 'Symbols', ['koko']],
  ['🔣', 'Symbols', ['symbols']],
  ['ℹ️', 'Symbols', ['information_source']],
  ['🔤', 'Symbols', ['abc']],
  ['🔡', 'Symbols', ['abcd']],
  ['🔠', 'Symbols', ['capital_abcd']],
  ['🆖', 'Symbols', ['ng']],
  ['🆗', 'Symbols', ['ok']],
  ['🆙', 'Symbols', ['up']],
  ['🆒', 'Symbols', ['cool']],
  ['🆕', 'Symbols', ['new']],
  ['🆓', 'Symbols', ['free']],
  ['0️⃣', 'Symbols', ['zero']],
  ['1️⃣', 'Symbols', ['one']],
  ['2️⃣', 'Symbols', ['two']],
  ['3️⃣', 'Symbols', ['three']],
  ['4️⃣', 'Symbols', ['four']],
  ['5️⃣', 'Symbols', ['five']],
  ['6️⃣', 'Symbols', ['six']],
  ['7️⃣', 'Symbols', ['seven']],
  ['8️⃣', 'Symbols', ['eight']],
  ['9️⃣', 'Symbols', ['nine']],
  ['🔟', 'Symbols', ['keycap_ten']],
  ['🔢', 'Symbols', ['1234']],
  ['#️⃣', 'Symbols', ['hash']],
  ['*️⃣', 'Symbols', ['asterisk']],
  ['▶️', 'Symbols', ['arrow_forward']],
  ['⏸', 'Symbols', ['pause_button']],
  ['⏯', 'Symbols', ['play_or_pause_button']],
  ['⏹', 'Symbols', ['stop_button']],
  ['⏺', 'Symbols', ['record_button']],
  ['⏭', 'Symbols', ['next_track_button']],
  ['⏮', 'Symbols', ['previous_track_button']],
  ['⏩', 'Symbols', ['fast_forward']],
  ['⏪', 'Symbols', ['rewind']],
  ['⏫', 'Symbols', ['arrow_double_up']],
  ['⏬', 'Symbols', ['arrow_double_down']],
  ['◀️', 'Symbols', ['arrow_backward']],
  ['🔼', 'Symbols', ['arrow_up_small']],
  ['🔽', 'Symbols', ['arrow_down_small']],
  ['➡️', 'Symbols', ['arrow_right']],
  ['⬅️', 'Symbols', ['arrow_left']],
  ['⬆️', 'Symbols', ['arrow_up']],
  ['⬇️', 'Symbols', ['arrow_down']],
  ['↗️', 'Symbols', ['arrow_upper_right']],
  ['↘️', 'Symbols', ['arrow_lower_right']],
  ['↙️', 'Symbols', ['arrow_lower_left']],
  ['↖️', 'Symbols', ['arrow_upper_left']],
  ['↕️', 'Symbols', ['arrow_up_down']],
  ['↔️', 'Symbols', ['left_right_arrow']],
  ['↪️', 'Symbols', ['arrow_right_hook']],
  ['↩️', 'Symbols', ['leftwards_arrow_with_hook']],
  ['⤴️', 'Symbols', ['arrow_heading_up']],
  ['⤵️', 'Symbols', ['arrow_heading_down']],
  ['🔀', 'Symbols', ['twisted_rightwards_arrows']],
  ['🔁', 'Symbols', ['repeat']],
  ['🔂', 'Symbols', ['repeat_one']],
  ['🔄', 'Symbols', ['arrows_counterclockwise']],
  ['🔃', 'Symbols', ['arrows_clockwise']],
  ['🎵', 'Symbols', ['musical_note']],
  ['🎶', 'Symbols', ['notes']],
  ['➕', 'Symbols', ['heavy_plus_sign']],
  ['➖', 'Symbols', ['heavy_minus_sign']],
  ['➗', 'Symbols', ['heavy_division_sign']],
  ['✖️', 'Symbols', ['heavy_multiplication_x']],
  ['💲', 'Symbols', ['heavy_dollar_sign']],
  ['💱', 'Symbols', ['currency_exchange']],
  ['™️', 'Symbols', ['tm']],
  ['©️', 'Symbols', ['copyright']],
  ['®️', 'Symbols', ['registered']],
  ['〰️', 'Symbols', ['wavy_dash']],
  ['➰', 'Symbols', ['curly_loop']],
  ['➿', 'Symbols', ['loop']],
  ['🔚', 'Symbols', ['end']],
  ['🔙', 'Symbols', ['back']],
  ['🔛', 'Symbols', ['on']],
  ['🔝', 'Symbols', ['top']],
  ['🔜', 'Symbols', ['soon']],
  ['✔️', 'Symbols', ['heavy_check_mark']],
  ['☑️', 'Symbols', ['ballot_box_with_check']],
  ['🔘', 'Symbols', ['radio_button']],
  ['⚪️', 'Symbols', ['white_circle']],
  ['⚫️', 'Symbols', ['black_circle']],
  ['🔴', 'Symbols', ['red_circle']],
  ['🔵', 'Symbols', ['large_blue_circle']],
  ['🔺', 'Symbols', ['small_red_triangle']],
  ['🔻', 'Symbols', ['small_red_triangle_down']],
  ['🔸', 'Symbols', ['small_orange_diamond']],
  ['🔹', 'Symbols', ['small_blue_diamond']],
  ['🔶', 'Symbols', ['large_orange_diamond']],
  ['🔷', 'Symbols', ['large_blue_diamond']],
  ['🔳', 'Symbols', ['white_square_button']],
  ['🔲', 'Symbols', ['black_square_button']],
  ['▪️', 'Symbols', ['black_small_square']],
  ['▫️', 'Symbols', ['white_small_square']],
  ['◾️', 'Symbols', ['black_medium_small_square']],
  ['◽️', 'Symbols', ['white_medium_small_square']],
  ['◼️', 'Symbols', ['black_medium_square']],
  ['◻️', 'Symbols', ['white_medium_square']],
  ['⬛️', 'Symbols', ['black_large_square']],
  ['⬜️', 'Symbols', ['white_large_square']],
  ['🔈', 'Symbols', ['speaker']],
  ['🔇', 'Symbols', ['mute']],
  ['🔉', 'Symbols', ['sound']],
  ['🔊', 'Symbols', ['loud_sound']],
  ['🔔', 'Symbols', ['bell']],
  ['🔕', 'Symbols', ['no_bell']],
  ['📣', 'Symbols', ['mega']],
  ['📢', 'Symbols', ['loudspeaker']],
  ['👁‍🗨', 'Symbols', ['eye_speech_bubble']],
  ['💬', 'Symbols', ['speech_balloon']],
  ['💭', 'Symbols', ['thought_balloon']],
  ['🗯', 'Symbols', ['right_anger_bubble']],
  ['♠️', 'Symbols', ['spades']],
  ['♣️', 'Symbols', ['clubs']],
  ['♥️', 'Symbols', ['hearts']],
  ['♦️', 'Symbols', ['diamonds']],
  ['🃏', 'Symbols', ['black_joker']],
  ['🎴', 'Symbols', ['flower_playing_cards']],
  ['🀄️', 'Symbols', ['mahjong']],
  ['🕐', 'Symbols', ['clock1']],
  ['🕑', 'Symbols', ['clock2']],
  ['🕒', 'Symbols', ['clock3']],
  ['🕓', 'Symbols', ['clock4']],
  ['🕔', 'Symbols', ['clock5']],
  ['🕕', 'Symbols', ['clock6']],
  ['🕖', 'Symbols', ['clock7']],
  ['🕗', 'Symbols', ['clock8']],
  ['🕘', 'Symbols', ['clock9']],
  ['🕙', 'Symbols', ['clock10']],
  ['🕚', 'Symbols', ['clock11']],
  ['🕛', 'Symbols', ['clock12']],
  ['🕜', 'Symbols', ['clock130']],
  ['🕝', 'Symbols', ['clock230']],
  ['🕞', 'Symbols', ['clock330']],
  ['🕟', 'Symbols', ['clock430']],
  ['🕠', 'Symbols', ['clock530']],
  ['🕡', 'Symbols', ['clock630']],
  ['🕢', 'Symbols', ['clock730']],
  ['🕣', 'Symbols', ['clock830']],
  ['🕤', 'Symbols', ['clock930']],
  ['🕥', 'Symbols', ['clock1030']],
  ['🕦', 'Symbols', ['clock1130']],
  ['🕧', 'Symbols', ['clock1230']],
  ['🏳️', 'Flags', ['white_flag']],
  ['🏴', 'Flags', ['black_flag']],
  ['🏁', 'Flags', ['checkered_flag']],
  ['🚩', 'Flags', ['triangular_flag_on_post']],
  ['🏳️‍🌈', 'Flags', ['rainbow_flag']],
  ['🇦🇫', 'Flags', ['afghanistan']],
  ['🇦🇽', 'Flags', ['aland_islands']],
  ['🇦🇱', 'Flags', ['albania']],
  ['🇩🇿', 'Flags', ['algeria']],
  ['🇦🇸', 'Flags', ['american_samoa']],
  ['🇦🇩', 'Flags', ['andorra']],
  ['🇦🇴', 'Flags', ['angola']],
  ['🇦🇮', 'Flags', ['anguilla']],
  ['🇦🇶', 'Flags', ['antarctica']],
  ['🇦🇬', 'Flags', ['antigua_barbuda']],
  ['🇦🇷', 'Flags', ['argentina']],
  ['🇦🇲', 'Flags', ['armenia']],
  ['🇦🇼', 'Flags', ['aruba']],
  ['🇦🇺', 'Flags', ['australia']],
  ['🇦🇹', 'Flags', ['austria']],
  ['🇦🇿', 'Flags', ['azerbaijan']],
  ['🇧🇸', 'Flags', ['bahamas']],
  ['🇧🇭', 'Flags', ['bahrain']],
  ['🇧🇩', 'Flags', ['bangladesh']],
  ['🇧🇧', 'Flags', ['barbados']],
  ['🇧🇾', 'Flags', ['belarus']],
  ['🇧🇪', 'Flags', ['belgium']],
  ['🇧🇿', 'Flags', ['belize']],
  ['🇧🇯', 'Flags', ['benin']],
  ['🇧🇲', 'Flags', ['bermuda']],
  ['🇧🇹', 'Flags', ['bhutan']],
  ['🇧🇴', 'Flags', ['bolivia']],
  ['🇧🇶', 'Flags', ['caribbean_netherlands']],
  ['🇧🇦', 'Flags', ['bosnia_herzegovina']],
  ['🇧🇼', 'Flags', ['botswana']],
  ['🇧🇷', 'Flags', ['brazil']],
  ['🇮🇴', 'Flags', ['british_indian_ocean_territory']],
  ['🇻🇬', 'Flags', ['british_virgin_islands']],
  ['🇧🇳', 'Flags', ['brunei']],
  ['🇧🇬', 'Flags', ['bulgaria']],
  ['🇧🇫', 'Flags', ['burkina_faso']],
  ['🇧🇮', 'Flags', ['burundi']],
  ['🇨🇻', 'Flags', ['cape_verde']],
  ['🇰🇭', 'Flags', ['cambodia']],
  ['🇨🇲', 'Flags', ['cameroon']],
  ['🇨🇦', 'Flags', ['canada']],
  ['🇮🇨', 'Flags', ['canary_islands']],
  ['🇰🇾', 'Flags', ['cayman_islands']],
  ['🇨🇫', 'Flags', ['central_african_republic']],
  ['🇹🇩', 'Flags', ['chad']],
  ['🇨🇱', 'Flags', ['chile']],
  ['🇨🇳', 'Flags', ['cn']],
  ['🇨🇽', 'Flags', ['christmas_island']],
  ['🇨🇨', 'Flags', ['cocos_islands']],
  ['🇨🇴', 'Flags', ['colombia']],
  ['🇰🇲', 'Flags', ['comoros']],
  ['🇨🇬', 'Flags', ['congo_brazzaville']],
  ['🇨🇩', 'Flags', ['congo_kinshasa']],
  ['🇨🇰', 'Flags', ['cook_islands']],
  ['🇨🇷', 'Flags', ['costa_rica']],
  ['🇨🇮', 'Flags', ['cote_divoire']],
  ['🇭🇷', 'Flags', ['croatia']],
  ['🇨🇺', 'Flags', ['cuba']],
  ['🇨🇼', 'Flags', ['curacao']],
  ['🇨🇾', 'Flags', ['cyprus']],
  ['🇨🇿', 'Flags', ['czech_republic']],
  ['🇩🇰', 'Flags', ['denmark']],
  ['🇩🇯', 'Flags', ['djibouti']],
  ['🇩🇲', 'Flags', ['dominica']],
  ['🇩🇴', 'Flags', ['dominican_republic']],
  ['🇪🇨', 'Flags', ['ecuador']],
  ['🇪🇬', 'Flags', ['egypt']],
  ['🇸🇻', 'Flags', ['el_salvador']],
  ['🇬🇶', 'Flags', ['equatorial_guinea']],
  ['🇪🇷', 'Flags', ['eritrea']],
  ['🇪🇪', 'Flags', ['estonia']],
  ['🇪🇹', 'Flags', ['ethiopia']],
  ['🇪🇺', 'Flags', ['eu', 'european_union']],
  ['🇫🇰', 'Flags', ['falkland_islands']],
  ['🇫🇴', 'Flags', ['faroe_islands']],
  ['🇫🇯', 'Flags', ['fiji']],
  ['🇫🇮', 'Flags', ['finland']],
  ['🇫🇷', 'Flags', ['fr']],
  ['🇬🇫', 'Flags', ['french_guiana']],
  ['🇵🇫', 'Flags', ['french_polynesia']],
  ['🇹🇫', 'Flags', ['french_southern_territories']],
  ['🇬🇦', 'Flags', ['gabon']],
  ['🇬🇲', 'Flags', ['gambia']],
  ['🇬🇪', 'Flags', ['georgia']],
  ['🇩🇪', 'Flags', ['de']],
  ['🇬🇭', 'Flags', ['ghana']],
  ['🇬🇮', 'Flags', ['gibraltar']],
  ['🇬🇷', 'Flags', ['greece']],
  ['🇬🇱', 'Flags', ['greenland']],
  ['🇬🇩', 'Flags', ['grenada']],
  ['🇬🇵', 'Flags', ['guadeloupe']],
  ['🇬🇺', 'Flags', ['guam']],
  ['🇬🇹', 'Flags', ['guatemala']],
  ['🇬🇬', 'Flags', ['guernsey']],
  ['🇬🇳', 'Flags', ['guinea']],
  ['🇬🇼', 'Flags', ['guinea_bissau']],
  ['🇬🇾', 'Flags', ['guyana']],
  ['🇭🇹', 'Flags', ['haiti']],
  ['🇭🇳', 'Flags', ['honduras']],
  ['🇭🇰', 'Flags', ['hong_kong']],
  ['🇭🇺', 'Flags', ['hungary']],
  ['🇮🇸', 'Flags', ['iceland']],
  ['🇮🇳', 'Flags', ['india']],
  ['🇮🇩', 'Flags', ['indonesia']],
  ['🇮🇷', 'Flags', ['iran']],
  ['🇮🇶', 'Flags', ['iraq']],
  ['🇮🇪', 'Flags', ['ireland']],
  ['🇮🇲', 'Flags', ['isle_of_man']],
  ['🇮🇱', 'Flags', ['israel']],
  ['🇮🇹', 'Flags', ['it']],
  ['🇯🇲', 'Flags', ['jamaica']],
  ['🇯🇵', 'Flags', ['jp']],
  ['🎌', 'Flags', ['crossed_flags']],
  ['🇯🇪', 'Flags', ['jersey']],
  ['🇯🇴', 'Flags', ['jordan']],
  ['🇰🇿', 'Flags', ['kazakhstan']],
  ['🇰🇪', 'Flags', ['kenya']],
  ['🇰🇮', 'Flags', ['kiribati']],
  ['🇽🇰', 'Flags', ['kosovo']],
  ['🇰🇼', 'Flags', ['kuwait']],
  ['🇰🇬', 'Flags', ['kyrgyzstan']],
  ['🇱🇦', 'Flags', ['laos']],
  ['🇱🇻', 'Flags', ['latvia']],
  ['🇱🇧', 'Flags', ['lebanon']],
  ['🇱🇸', 'Flags', ['lesotho']],
  ['🇱🇷', 'Flags', ['liberia']],
  ['🇱🇾', 'Flags', ['libya']],
  ['🇱🇮', 'Flags', ['liechtenstein']],
  ['🇱🇹', 'Flags', ['lithuania']],
  ['🇱🇺', 'Flags', ['luxembourg']],
  ['🇲🇴', 'Flags', ['macau']],
  ['🇲🇰', 'Flags', ['macedonia']],
  ['🇲🇬', 'Flags', ['madagascar']],
  ['🇲🇼', 'Flags', ['malawi']],
  ['🇲🇾', 'Flags', ['malaysia']],
  ['🇲🇻', 'Flags', ['maldives']],
  ['🇲🇱', 'Flags', ['mali']],
  ['🇲🇹', 'Flags', ['malta']],
  ['🇲🇭', 'Flags', ['marshall_islands']],
  ['🇲🇶', 'Flags', ['martinique']],
  ['🇲🇷', 'Flags', ['mauritania']],
  ['🇲🇺', 'Flags', ['mauritius']],
  ['🇾🇹', 'Flags', ['mayotte']],
  ['🇲🇽', 'Flags', ['mexico']],
  ['🇫🇲', 'Flags', ['micronesia']],
  ['🇲🇩', 'Flags', ['moldova']],
  ['🇲🇨', 'Flags', ['monaco']],
  ['🇲🇳', 'Flags', ['mongolia']],
  ['🇲🇪', 'Flags', ['montenegro']],
  ['🇲🇸', 'Flags', ['montserrat']],
  ['🇲🇦', 'Flags', ['morocco']],
  ['🇲🇿', 'Flags', ['mozambique']],
  ['🇲🇲', 'Flags', ['myanmar']],
  ['🇳🇦', 'Flags', ['namibia']],
  ['🇳🇷', 'Flags', ['nauru']],
  ['🇳🇵', 'Flags', ['nepal']],
  ['🇳🇱', 'Flags', ['netherlands']],
  ['🇳🇨', 'Flags', ['new_caledonia']],
  ['🇳🇿', 'Flags', ['new_zealand']],
  ['🇳🇮', 'Flags', ['nicaragua']],
  ['🇳🇪', 'Flags', ['niger']],
  ['🇳🇬', 'Flags', ['nigeria']],
  ['🇳🇺', 'Flags', ['niue']],
  ['🇳🇫', 'Flags', ['norfolk_island']],
  ['🇲🇵', 'Flags', ['northern_mariana_islands']],
  ['🇰🇵', 'Flags', ['north_korea']],
  ['🇳🇴', 'Flags', ['norway']],
  ['🇴🇲', 'Flags', ['oman']],
  ['🇵🇰', 'Flags', ['pakistan']],
  ['🇵🇼', 'Flags', ['palau']],
  ['🇵🇸', 'Flags', ['palestinian_territories']],
  ['🇵🇦', 'Flags', ['panama']],
  ['🇵🇬', 'Flags', ['papua_new_guinea']],
  ['🇵🇾', 'Flags', ['paraguay']],
  ['🇵🇪', 'Flags', ['peru']],
  ['🇵🇭', 'Flags', ['philippines']],
  ['🇵🇳', 'Flags', ['pitcairn_islands']],
  ['🇵🇱', 'Flags', ['poland']],
  ['🇵🇹', 'Flags', ['portugal']],
  ['🇵🇷', 'Flags', ['puerto_rico']],
  ['🇶🇦', 'Flags', ['qatar']],
  ['🇷🇪', 'Flags', ['reunion']],
  ['🇷🇴', 'Flags', ['romania']],
  ['🇷🇺', 'Flags', ['ru']],
  ['🇷🇼', 'Flags', ['rwanda']],
  ['🇧🇱', 'Flags', ['st_barthelemy']],
  ['🇸🇭', 'Flags', ['st_helena']],
  ['🇰🇳', 'Flags', ['st_kitts_nevis']],
  ['🇱🇨', 'Flags', ['st_lucia']],
  ['🇵🇲', 'Flags', ['st_pierre_miquelon']],
  ['🇻🇨', 'Flags', ['st_vincent_grenadines']],
  ['🇼🇸', 'Flags', ['samoa']],
  ['🇸🇲', 'Flags', ['san_marino']],
  ['🇸🇹', 'Flags', ['sao_tome_principe']],
  ['🇸🇦', 'Flags', ['saudi_arabia']],
  ['🇸🇳', 'Flags', ['senegal']],
  ['🇷🇸', 'Flags', ['serbia']],
  ['🇸🇨', 'Flags', ['seychelles']],
  ['🇸🇱', 'Flags', ['sierra_leone']],
  ['🇸🇬', 'Flags', ['singapore']],
  ['🇸🇽', 'Flags', ['sint_maarten']],
  ['🇸🇰', 'Flags', ['slovakia']],
  ['🇸🇮', 'Flags', ['slovenia']],
  ['🇸🇧', 'Flags', ['solomon_islands']],
  ['🇸🇴', 'Flags', ['somalia']],
  ['🇿🇦', 'Flags', ['south_africa']],
  ['🇬🇸', 'Flags', ['south_georgia_south_sandwich_islands']],
  ['🇰🇷', 'Flags', ['kr']],
  ['🇸🇸', 'Flags', ['south_sudan']],
  ['🇪🇸', 'Flags', ['es']],
  ['🇱🇰', 'Flags', ['sri_lanka']],
  ['🇸🇩', 'Flags', ['sudan']],
  ['🇸🇷', 'Flags', ['suriname']],
  ['🇸🇿', 'Flags', ['swaziland']],
  ['🇸🇪', 'Flags', ['sweden']],
  ['🇨🇭', 'Flags', ['switzerland']],
  ['🇸🇾', 'Flags', ['syria']],
  ['🇹🇼', 'Flags', ['taiwan']],
  ['🇹🇯', 'Flags', ['tajikistan']],
  ['🇹🇿', 'Flags', ['tanzania']],
  ['🇹🇭', 'Flags', ['thailand']],
  ['🇹🇱', 'Flags', ['timor_leste']],
  ['🇹🇬', 'Flags', ['togo']],
  ['🇹🇰', 'Flags', ['tokelau']],
  ['🇹🇴', 'Flags', ['tonga']],
  ['🇹🇹', 'Flags', ['trinidad_tobago']],
  ['🇹🇳', 'Flags', ['tunisia']],
  ['🇹🇷', 'Flags', ['tr']],
  ['🇹🇲', 'Flags', ['turkmenistan']],
  ['🇹🇨', 'Flags', ['turks_caicos_islands']],
  ['🇹🇻', 'Flags', ['tuvalu']],
  ['🇺🇬', 'Flags', ['uganda']],
  ['🇺🇦', 'Flags', ['ukraine']],
  ['🇦🇪', 'Flags', ['united_arab_emirates']],
  ['🇬🇧', 'Flags', ['gb', 'uk']],
  ['🇺🇸', 'Flags', ['us']],
  ['🇻🇮', 'Flags', ['us_virgin_islands']],
  ['🇺🇾', 'Flags', ['uruguay']],
  ['🇺🇿', 'Flags', ['uzbekistan']],
  ['🇻🇺', 'Flags', ['vanuatu']],
  ['🇻🇦', 'Flags', ['vatican_city']],
  ['🇻🇪', 'Flags', ['venezuela']],
  ['🇻🇳', 'Flags', ['vietnam']],
  ['🇼🇫', 'Flags', ['wallis_futuna']],
  ['🇪🇭', 'Flags', ['western_sahara']],
  ['🇾🇪', 'Flags', ['yemen']],
  ['🇿🇲', 'Flags', ['zambia']],
  ['🇿🇼', 'Flags', ['zimbabwe']]
]

export default emojisDefault
